import React, { createContext, useState, useEffect } from "react";
import contentFile from "../../constants/contentFile.json";
import { useNavigate, useSearchParams } from "react-router-dom";
import routeContstants from "../../constants/routeConstants.json";
import { setPasswordApi, validateResetPasswordToken } from "../../api/Api";
import {
  capitalLetterValidate,
  lowercaseLetterValidate,
  singleNumber,
  miniCharacters,
  specialCharacter,
  spaceCheck,
} from "../../utils/service";

export const SetPasswordContext = createContext({});

export const SetPasswordContextProvider = ({ children }) => {
  const pageContent = contentFile.authPage;
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  // Validation Error message state

  const [passwordValidateMsg, setPasswordValidateMsg] = useState(" ");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [errorAlertShow, setErrorAlertShow] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [statusCode, setStatusCode] = useState(0);
  const [resetError, setResetError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // Password Show and Hide
  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [successModal, setSuccessModal] = useState(false);
  const [validateResetToken, setValidateResetToken] = useState(false);

  // Get token from url
  const [params] = useSearchParams();

  //get token from url and covert to array for removing = by giving .split("=")
  const tokenValue = params.toString().split("=");

  const toggleEyeIcon = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  const toggleEyeIconConfirm = () => {
    if (confirmPasswordType === "password") {
      setConfirmPasswordType("text");
    } else {
      setConfirmPasswordType("password");
    }
  };

  //set password validation
  const checkResetPassword = (password) => {
    if (password === "") {
      setResetError(pageContent.resetValidationNew);
      return false;
    } else if (spaceCheck(password)) {
      setResetError("Blank passwords shall not be permitted");
    } else if (!capitalLetterValidate(password)) {
      setResetError("At least one capital letter required");
      return false;
    } else if (!lowercaseLetterValidate(password)) {
      setResetError("At least one small letter required");
      return false;
    } else if (!singleNumber(password)) {
      setResetError("At least one number required");
      return false;
    } else if (!specialCharacter(password)) {
      setResetError(
        "At least one special character required, ~, @,#,$, %,^, &,*,(,)"
      );
      return false;
    } else if (!miniCharacters(password)) {
      setResetError("Minimum of 8 characters required");
      return false;
    } else {
      setResetError("");
      return true;
    }
  };

  // Password validation

  const checkConfirmPassword = (value) => {
    if (value === "") {
      setPasswordValidateMsg(pageContent.passwordRequired);
      return false;
    } else if (password !== value) {
      setPasswordValidateMsg(pageContent.newPasswordMtach);
      return false;
    } else {
      setPasswordValidateMsg("");
      return true;
    }
  };

  // set input value to state using handle change

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    checkResetPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    checkConfirmPassword(e.target.value);
  };

  // Success Modal close
  const handleSucessClose = () => {
    navigate(routeContstants.LOGIN);
  };

  const resetPasswordTokenValidation = async(token) =>{
    setSpinnerStatus(true);
    try {
      const response  = await validateResetPasswordToken(token);
      if(response?.data?.statusCode == 200){
        console.log('response?.data')
        setValidateResetToken(true);
        setSpinnerStatus(false)
      }
    } catch (error) {
      setValidateResetToken(false);
      setSpinnerStatus(false)
    }
  }

  useEffect(()=>{
    resetPasswordTokenValidation(tokenValue[1]);
  },[])

  const submitnewPasswordapi = async (e) => {
    e.preventDefault();
    const validResetPassword = checkResetPassword(password);
    const validConfirmPassword = checkConfirmPassword(confirmPassword);
    if (validResetPassword && validConfirmPassword) {
      if (password === confirmPassword) {
        const tokenData = {
          token: tokenValue[1],
          password: password,
        };
        try {
          const response = await setPasswordApi(tokenData);

          if (response?.data?.statusCode === 200) {
            setSpinnerStatus(false);
            setSuccessModal(true);
            setSuccessMessage(response?.data?.message);
          }
        } catch (error) {
          setStatusCode(error?.response?.data?.statusCode);
          if (
            error?.response?.data?.statusCode === 401 ||
            error?.response?.data?.statusCode === 400
          ) {
            setSpinnerStatus(false);
            const errorMessage = error?.response?.data?.message;
            setErrorAlertMessage(errorMessage);
            setErrorAlertShow(true);
          } else {
            setSpinnerStatus(false);
            setErrorAlertMessage("Something went wrong...");
            setErrorAlertShow(true);
          }
        }
      }
    }
  };

  const pageToForgotpassword = () => {
    navigate(routeContstants.FORGOT_PASSWORD);
  };

  const providerValue = {
    passwordType,
    confirmPasswordType,
    toggleEyeIconConfirm,
    toggleEyeIcon,
    pageContent,
    successMessage,
    confirmPassword,
    submitnewPasswordapi,
    password,
    handleConfirmPasswordChange,
    pageToForgotpassword,
    spinnerStatus,
    handlePasswordChange,
    passwordValidateMsg,
    errorAlertMessage,
    errorAlertShow,
    setErrorAlertMessage,
    setErrorAlertShow,
    statusCode,
    successModal,
    resetError,
    handleSucessClose,
    validateResetToken
  };
  return (
    <SetPasswordContext.Provider value={providerValue}>
      {children}
    </SetPasswordContext.Provider>
  );
};
